module.exports = __webpack_public_path__ + "img/优异的数据搜索能力@2x.7c9a322a.png";